<template>
  <div class="fault-view">
    <div class="top-view">
      <!-- <div>故障统计</div> -->
      <el-form :inline="true" :model="searchForm">
        <el-form-item>
          <el-cascader v-model="searchForm.cs" :options="shlist"/>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.shlx" placeholder="商户类型">
            <el-option label="类型1" value="1"></el-option>
            <el-option label="类型2" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-view">
      <div class="total-view">
        <div class="total-item">
          <div class="total-item-label">今日故障数</div>
          <div><span class="num">{{totalInfo.dayTotal}}</span> 昨日 <span class="small-num">{{totalInfo.yesTotal}}</span></div>
        </div>
        <div class="total-item">
          <div class="total-item-label">较昨日同期<i class="el-icon-question" /></div>
          <div class="num">{{totalInfo.TB}}%</div>
        </div>
        <div class="total-item">
          <div class="total-item-label">故障总数</div>
          <div class="num">{{totalInfo.total}}</div>
        </div>
      </div>
      <div class="total-chart-view">
        <div class="total-chart-top">
          <div class="total-chart-title">故障统计 <i class="el-icon-question" /></div>
          <el-date-picker
            v-model="times"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </div>
        <div class="total-chart" ref="lineChart"></div>
      </div>
      <div class="total-chart-view">
        <div class=""></div>
        <div class="type-chart" ref="typeChart"></div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  components: {
  },
  data() {
    return {
      searchForm: {
        cs: '',
        shlx: ''
      },
      shlist: [
        {
          value: 'zhinan',
          label: '全部厂商',
          children: [
            { value: 'shejiyuanze', label: '商户1' },
            { value: 'shejiyuanze', label: '商户2' }
          ]
        }
      ],

      totalInfo: {
        dayTotal: 0,
        yesTotal: 0,
        TB: 100,
        total: 28
      },
      times: ['2025-02-14', '2025-02-20'],
      lineChart: null,
      pieChart: null
    }
  },
  created() {},
  mounted() {
    this.getList()
    this.lineChart = this.$echarts.init(this.$refs.lineChart, null, { renderer: 'svg' })
    this.pieChart = this.$echarts.init(this.$refs.typeChart, null, { renderer: 'svg' })
    this.$nextTick(() => {
      this.setLineOption()
      this.setPieOption()
    })
  },
  methods: {
    onSearch() {

    },
    getList() {

    },
    setLineOption() {
      const option = {
        xAxis: {
          type: 'category',
          data: ['2025.02.14', '2025.02.15', '2025.02.16', '2025.02.17', '2025.02.18', '2025.02.19', '2025.02.20']
        },
        yAxis: {
          type: 'value',
          name: '故障数',
          nameTextStyle: {
            fontSize: 14,
            align: 'right',
            color: '#0f73e6',
            borderColor: '#0f73e6',
            borderWidth: 1,
            padding: [5, 10],
            borderRadius: 3
          }
        },
        legend: {
          bottom: 0
        },
        grid: {
          top: 50,
          left: 35,
          bottom: 25,
          right: 15,
          containLabel: true
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: '导出'
            }
          }
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line',
            name: '故障数',
            symbol: 'circle'
          }
        ]
      }
      this.lineChart.setOption(option)
    },
    setPieOption() {
      const option = {
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: '导出'
            }
          }
        },
        title: {
          text: '故障类型分布',
          left: 0,
          borderColor: '#0f73e6',
          borderWidth: 1,
          padding: [5, 10],
          borderRadius: 3,
          textStyle: {
            fontSize: 14,
            color: '#0f73e6'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          width: '50%',
          left: 'center',
          top: 30,
          itemStyle: {
            fontSize: 12
          },
          data: [
            'Direct',
            'Marketing',
            'Search Engine',
            'Email',
            'Union Ads',
            'Video Ads',
            'Baidu',
            'Google',
            'Bing',
            'Others'
          ]
        },
        series: [
          {
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '30%'],
            center: ['50%', '65%'],
            label: {
              position: 'inner',
              fontSize: 14
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 1548, name: 'Search Engine' },
              { value: 775, name: 'Direct' },
              { value: 679, name: 'Marketing', selected: true }
            ]
          },
          {
            type: 'pie',
            radius: ['45%', '60%'],
            center: ['50%', '65%'],
            avoidLabelOverlap: true,
            labelLine: {
              length: 30
            },
            label: {
              formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
              backgroundColor: '#F6F8FC',
              borderColor: '#8C8D8E',
              borderWidth: 1,
              borderRadius: 4,
              rich: {
                a: {
                  color: '#6E7079',
                  lineHeight: 22,
                  align: 'center'
                },
                hr: {
                  borderColor: '#8C8D8E',
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                b: {
                  color: '#4C5058',
                  fontSize: 14,
                  fontWeight: 'bold',
                  lineHeight: 33
                },
                per: {
                  color: '#fff',
                  backgroundColor: '#4C5058',
                  padding: [3, 4],
                  borderRadius: 4
                }
              }
            },
            data: [
              { value: 1048, name: 'Search Engine' },
              { value: 735, name: 'Direct' },
              { value: 580, name: 'Email' },
              { value: 484, name: 'Union Ads' },
              { value: 300, name: 'Video Ads' }
            ]
          }
        ]
      }
      this.pieChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.fault-view {
  background: rgba(255,255,255,0.1);
  .top-view {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content-view {
    padding: 15px;
    background: #fff;
    .total-view {
      width: 100%;
      height: 80px;
      border: 1px solid #eee;
      border-radius: 4px;
      display: flex;
      align-items: center;
      .total-item {
        width: 33.3%;
        padding-left: 30px;
        border-left: 1px solid #eee;
        &:first-child {
          border-left: 0;
        }
        &-label {
          color: #555;
          font-size: 12px;
          margin-bottom: 10px;
          i {
            margin-left: 5px;
          }
        }
        .num {
          font-size: 15px;
          font-weight: bold;
        }
      }
    }
    .total-chart-view {
      margin-bottom: 15px;
      .total-chart-top {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .total-chart-title {
        font-weight: bold;
        color: #333;
        padding: 12px 0;
      }
      .total-chart {
        width: 100%;
        height: 300px;
      }
      .type-chart {
        width: 100%;
        height: 500px;
      }
    }
  }

}
</style>
